import type { FeatureGateSeed } from './feature-gate-registry';

/**
 * The office messenger gate (plan docs/plans/2026-10-25-feat-office-messenger-mvp-plan.md, D12),
 * spread into FEATURE_GATE_SEEDS in feature-gate-registry.ts at its place in its order. The
 * database seeds the row (migration 20261025041736_office_messenger_schema.sql); this entry gives
 * the platform's Feature Gates list its label.
 */
export const OFFICE_MESSENGER_FEATURE_GATE_SEEDS = {
  office_messenger: {
    label: 'Office messenger',
    shortLabel: 'Chat',
    description:
      'Staff chat inside the office: public and private channels, direct messages, mentions, reactions and threads, on web and iPhone. The messenger functions and realtime topics refuse every office while the gate is off.',
    group: 'correspondence',
  },
} satisfies Record<string, FeatureGateSeed>;
